import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import PrimaryButton from '../components/PrimaryButton';
import { ProjectAuthorChip } from '../components/ProjectAuthorChip';
import ProjectResourceButton from '../components/ProjectResourceButton';
import { projectsData } from '../data/projectsData';
import Footer from '../components/Footer';

const ProjectDetails = () => {
    const { slug } = useParams();
    const project = projectsData.find((item) => item.slug === slug);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [slug]);

    if (!project) {
        return (
            <main className="min-h-screen bg-earth-50 px-8 py-32 lg:px-6 flex flex-col">
                <div className="mx-auto flex w-full max-w-7xl flex-1 flex-col gap-6">
                    <h1 className="text-3xl font-bold text-earth-900">Project not found</h1>
                    <p className="text-earth-700">The selected project page is not available.</p>
                    <Link to="/">
                        <PrimaryButton>Back to Home</PrimaryButton>
                    </Link>
                </div>
                <section className="scroll-mt-24 w-full max-w-7xl mx-auto mb-4">
                    <Footer />
                </section>
            </main>
        );
    }

    const contentSource = project.text?.trim() ? project.text : project.description;
    const paragraphs = contentSource
        .split(/\n\s*\n/)
        .map((paragraph) => paragraph.trim())
        .filter(Boolean);

    return (
        <main className="min-h-screen bg-earth-50 px-8 pt-28 lg:px-6 dark:bg-earth-900 flex flex-col">
            <section className="mx-auto w-full max-w-7xl flex-1">
                <div className="max-w-6xl space-y-10 text-earth-900 dark:text-earth-50">
                    <header className="space-y-6">
                        <h1 className="text-3xl font-bold leading-tight sm:text-4xl lg:text-5xl">
                            {project.title}
                        </h1>
                    </header>

                    <div className="space-y-5 text-base leading-8 text-earth-800 dark:text-earth-100 sm:text-lg">
                        {paragraphs.map((paragraph, index) => (
                            <p key={`${project.slug}-paragraph-${index}`}>
                                {paragraph}
                            </p>
                        ))}
                    </div>

                    {project.users?.length ? (
                        <section className="space-y-4 pt-6">
                            <h2 className="text-2xl font-semibold text-earth-900 dark:text-earth-50">
                                Authors
                            </h2>
                            <div className="flex flex-wrap gap-3">
                                {project.users.map((user) => (
                                    <ProjectAuthorChip key={`${project.slug}-${user.name}`} name={user.name} gitHubLink={user.gitHubLink} />
                                ))}
                            </div>
                        </section>
                    ) : null}

                    {(project.repoLink || project.report) ? (
                        <section className="space-y-4 pt-2">
                            <h2 className="text-2xl font-semibold text-earth-900 dark:text-earth-50">
                                More Resources
                            </h2>
                            <div className="flex flex-wrap gap-4">
                                <ProjectResourceButton href={project.report}>
                                    Report
                                </ProjectResourceButton>
                                <ProjectResourceButton href={project.repoLink}>
                                    Repository
                                </ProjectResourceButton>
                            </div>
                        </section>
                    ) : null}
                </div>
            </section>

            <Footer />
        </main>
    );
};

export default ProjectDetails;
